import React from 'react'
import { Home } from 'react-feather'
import Header from "../Components/Header.js"
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

export default function Disclaimer() {

  let navigate = useNavigate()  
 
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const styles = {
    container: {
      maxWidth: '800px',
      margin: '20px auto',
      padding: '30px',
      backgroundColor: '#f9f9f9',
      color: '#333',
      borderRadius: '8px',
      border: '1px solid #ddd',
      fontFamily: 'sans-serif',
      lineHeight: '1.6',
      paddingTop: "60px",
    },
    title: {
      color: '#c0392b',
      textAlign: 'center',
      marginBottom: '25px',
      fontSize: '1.8rem',
      fontWeight: 'bold',
    },
    section: {
      marginBottom: '20px',
    },
    heading: {
      fontSize: '1.1rem',
      fontWeight: '600',
      textTransform: 'uppercase',
      marginBottom: '10px',
      color: '#2c3e50',
    },
    list: {
      paddingLeft: '20px',
      marginTop: '10px',
    },
    footer: {
      marginTop: '30px',
      paddingTop: '15px',
      borderTop: '1px solid #ccc',
      fontSize: '0.85rem',
      color: '#777',
      fontStyle: 'italic',
      textAlign: 'center',
    }
  };

  return (
    <>
    <Header />
    <div style={styles.container}>
      <h2 style={styles.title}>Disclaimer e Limitazione di Responsabilità</h2>

      <section style={styles.section}>
        <h3 style={styles.heading}>1. Finalità puramente informativa</h3>
        <p>
          I contenuti dell'App (testi, foto) sono forniti a <strong>puro scopo informativo</strong>. 
          Non sostituiscono in alcun modo l'assistenza di una guida professionale o la consulenza tecnica.
        </p>
      </section>

      <section style={styles.section}>
        <h3 style={styles.heading}>2. Assunzione del rischio</h3>
        <p>
          La montagna presenta rischi intrinseci. L'utente accetta che le condizioni dei sentieri possano variare per meteo o eventi naturali. 
          Ogni attività è intrapresa sotto l'<strong>esclusiva responsabilità</strong> dell'utente.
        </p>
      </section>

      <section style={styles.section}>
        <h3 style={styles.heading}>3. Esclusione di responsabilità</h3>
        <p>
          L'autore non garantisce l'accuratezza totale dei dati e <strong>declina ogni responsabilità</strong> per incidenti o danni derivanti da:
        </p>
        <ul style={styles.list}>
          <li>Cattiva interpretazione di testi, difficoltà.</li>
          <li>Inesattezze, refusi o indicazioni insufficienti.</li>
          <li>Mancato aggiornamento sullo stato reale dei percorsi.</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h3 style={styles.heading}>4. Valutazione soggettiva</h3>
        <p>
          È responsabilità dell'escursionista valutare le proprie capacità fisiche, l'attrezzatura e il meteo. 
          Le descrizioni dell'App non sostituiscono l'esperienza diretta sul campo.
        </p>
      </section>
      <div className="d-flex flex-column align-items-center pt-3">
        {/* Icona Home */}
        <Home 
          size={48} 
          style={{ cursor: 'pointer', color: '#1b5e20' }} 
          onClick={() => navigate('/')}
        />
      </div>

      <div style={styles.footer}>
        Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')} — Consultare sempre fonti ufficiali e previsioni meteo prima di partire.
      </div>
    </div>
    </>
  )
}
